




















import { Component, Prop, Vue } from "vue-property-decorator";
import { UserModel } from "../../apis";

@Component({})
export default class AppButtonAddShipment extends Vue {
  get me() {
    return this.$store.getters.user as UserModel;
  }
  onAddShipment() {
    return this.$router.push({ name: "add-shipment" });
  }
  onExport() {
    this.$store.commit("EXPORT");
  }
}
